import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'table-container-header',
  templateUrl: './table-container-header.component.html',
})
export class TableContainerHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
